<template>
  <div v-loading="loading">
    <div class="detail_echart_top">
      <div
        class="detail_top_item"
        v-for="(item, index) in gridList"
        :key="index"
      >
        <div class="detail_top_item_title">{{ item.value | FormatNum }}</div>
        <div class="detail_top_item_value">{{ item.label }}</div>
      </div>
    </div>
    <div class="detail_echart_con">
      <div class="table_header">
        <div class="table_header_title">{{ $t("Relationship.Ownership") }}</div>
        <div class="table_header_menus">
          <el-select
            clearable
            v-model="searchCompany"
            filterable
            class="search-select-con"
            popper-class="new-search-select"
            :popper-append-to-body="true"
            :placeholder="$t('Relationship.Entercompanyname')"
            @change="selectCompany"
            no-match-text="The Subject company has no affiliation with the inquired company."
          >
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
              <OverflowTooltip :tip="item.name" />
            </el-option>
          </el-select>

          <div class="display_switch">
            <div @click="changeSwitch(false)" :class="{ active: !isShowD3 }">
              <i class="iconfont icon-zuzhi" />
            </div>
            <div @click="changeSwitch(true)" :class="{ active: isShowD3 }">
              <i class="iconfont icon-guanxichaxunyoushangguanxi" />
            </div>
          </div>
        </div>
      </div>
      <div class="detail_echart_con_box">
        <div class="penetration_d3" v-if="isShowD3">
          <!-- 穿透图 -->
          <EquityD3 :chartData="chartData" chartType="ubo"></EquityD3>
        </div>
        <template v-else>
          <!--关系图左边表格  -->
          <div class="ownership-graph-left">
            <div class="ownership-graph-left-item flex-center-start">
              <div class="ownership-graph-left-name">
                {{ $t("Relationship.UItimateBeneficiaryOwner") }}
              </div>
              <div class="ownership-graph-left-desc">
                {{ shareholderChartSummaryObject?.ultimateBeneficiary }}
              </div>
            </div>
            <div class="ownership-graph-left-item flex-center-start">
              <div class="ownership-graph-left-name">
                {{ $t("Relationship.ShareholderLevel") }}
              </div>
              <div class="ownership-graph-left-desc">
                {{
                  shareholderChartSummaryObject?.shareholdingLayers | FormatNum
                }}
              </div>
            </div>
            <div class="ownership-graph-left-item flex-center-start">
              <div class="ownership-graph-left-name">
                {{ $t("Relationship.PartiesInvolved") }}
              </div>
              <div class="ownership-graph-left-desc">
                {{ shareholderChartSummaryObject?.partiesInvolved | FormatNum }}
              </div>
            </div>
            <div class="ownership-graph-left-item flex-center-start">
              <div class="ownership-graph-left-name">
                {{ $t("Relationship.RelatedCompanies") }}
              </div>
              <div
                class="ownership-graph-left-desc"
                :class="{
                  link_text: shareholderChartSummaryObject?.relatedCompany > 0,
                }"
                @click="linktoRelated"
              >
                {{ shareholderChartSummaryObject?.relatedCompany | FormatNum }}
              </div>
            </div>
            <div class="ownership-graph-left-item flex-center-start">
              <div class="ownership-graph-left-name">
                {{ $t("Relationship.CoShareholders") }}
              </div>
              <div class="ownership-graph-left-desc">
                {{
                  shareholderChartSummaryObject?.companyShareholders | FormatNum
                }}
              </div>
            </div>
            <div class="ownership-graph-left-item flex-center-start">
              <div class="ownership-graph-left-name">
                {{ $t("Relationship.NGOShareholders") }}
              </div>
              <div class="ownership-graph-left-desc">
                {{ shareholderChartSummaryObject?.ngoShareholders | FormatNum }}
              </div>
            </div>
            <div class="ownership-graph-left-item flex-center-start">
              <div class="ownership-graph-left-name">
                {{ $t("Relationship.NaturalPersonShareholders") }}
              </div>
              <div class="ownership-graph-left-desc">
                {{
                  shareholderChartSummaryObject?.naturalPersonShareholder
                    | FormatNum
                }}
              </div>
            </div>
            <div class="ownership-graph-left-item flex-center-start">
              <div class="ownership-graph-left-name">
                {{ $t("Relationship.SubjectsInvestments") }}
              </div>
              <div class="ownership-graph-left-desc">
                {{
                  shareholderChartSummaryObject?.subjectInvestments | FormatNum
                }}
              </div>
            </div>
          </div>
          <!-- 关系图 -->
          <div class="detail_echart_d3">
            <RelationshipD3
              ref="d3Ref"
              :relationshipSearch="relationshipSearch"
              :chartData="relationshipChartData"
            />
          </div>
        </template>
      </div>
    </div>
    <div class="detail_echart_table">
      <div class="table_header">
        <div class="table_header_title">
          {{ $t("Relationship.CompanyShareholders") }}
        </div>
      </div>
      <el-table
        class="risk_table"
        :data="tableData"
        height="100%"
        ref="tableRef"
      >
        <el-table-column
          prop="name"
          :label="$t('Relationship.Name')"
          min-width="200"
        >
          <template slot-scope="scope">
            <div class="flex_center_start_box">
              <span
                class="link_hover_text"
                v-if="
                  scope.row.id3a
                    .split('')
                    .every((char) => char >= '0' && char <= '9')
                "
                @click="goDetail(scope.row)"
              >
                {{ scope.row.name }}</span
              >
              <span v-else>
                {{ scope.row.name }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="country"
          align="center"
          :label="$t('Relationship.Country')"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="location"
          align="center"
          :label="$t('Relationship.Location')"
          min-width="110"
        >
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('Relationship.Type')"
          align="center"
          min-width="145"
        >
        </el-table-column>
        <el-table-column
          prop="shares"
          align="center"
          :label="$t('Relationship.Shares')"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="relations"
          align="center"
          :label="$t('Relationship.Relations')"
          min-width="100"
        >
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <Page
          :keyword="$t('Relationship.Ownership')"
          :fontColor="'#B44818'"
          :total="total"
          :pageSize="searchParams.pageSize"
          :currentPage="searchParams.currentPage"
          @onPageChange="onChangePage"
        ></Page>
      </div>
    </div>

    <Tips :dialogVisible.sync="isShowTips"></Tips>
  </div>
</template>
<script>
import { formatNum } from "@/views/company/details/Background/utils";

import { mixins1 } from "@/mixins/index";
import Page from "@/views/newLayout/page.vue";
import EquityD3 from "@/views/company/details/Background/componet/index.vue";
import RelationshipD3 from "./Com_Relationship-d3.vue";
import Tips from "@/views/newLayout/tips.vue";
import {
  getCompanyDetailchirt,
  getOwnership,
  getShareholderSummary,
  getShareholderChartSummary,
} from "@/api/companyApi";
import {
  getShareholderChart,
  getRelationshipInquiryOfHolder,
} from "@/api/uboApi.js";

import {
  formatterTxt,
  formatListMax50,
} from "@/views/company/details/Background/utils";

export default {
  name: "UboDetail2",
  mixins: [mixins1],
  components: {
    Page,
    EquityD3,
    Tips,
    RelationshipD3,
  },
  data() {
    return {
      loading: false,
      isShowTips: false,
      isShowD3: false,
      total: 0,
      searchParams: {
        currentPage: 1,
        pageSize: 5,
      },
      gridList: [
        { label: this.$t("Relationship.UItimateBeneficiaryOwner"), value: "-" },
        // { label: this.$t("Relationship.ControllingShareholder"), value: "-" },
        { label: this.$t("Relationship.PartiesInvolved"), value: "-" },
        {
          label: this.$t("Relationship.NaturalPersonShareholders"),
          value: "-",
        },
        { label: this.$t("Relationship.CorporateShareholders"), value: "-" },
        { label: this.$t("Relationship.ShareholderLevel"), value: "-" },
      ],
      shareholderChartSummaryObject: {},
      tableData: [],
      chartData: {},
      relationshipChartData: {},
      searchCompany: "",
      companyList: [],
      relationshipSearch: [
        { label: this.$t("Relationship.ShareholdingLayers"), value: "-" },
        {
          label: this.$t("Relationship.DirectShareholdingPercentage"),
          value: "-",
        },
        { label: this.$t("Relationship.TotalOwnershipPercentage"), value: "-" },
        { label: this.$t("Relationship.UItimateBeneficiaryOwner"), value: "-" },
      ],
    };
  },
  methods: {
    changeSwitch(val) {
      this.isShowD3 = val;
    },
    onChangePage(param) {
      this.searchParams.currentPage = param.page;
      this.searchParams.pageSize = param.pageSize;
      this.getOwnership();
    },
    linktoRelated() {
      if (this.shareholderChartSummaryObject?.relatedCompany > 0) {
        this.$router.push({
          path: "/ubo/detail",
          query: {
            id3a: this.$route.query.id3a,
            keyword: this.$route.query.keyword,
            selectKey: this.$route.query.selectKey,
            type: 4,
          },
        });
      }
    },
    // 跳转ubo详细
    goDetail(row) {
      let routeData = this.$router.resolve({
        path: "/ubo/detail",
        query: {
          id3a: row.id3a,
          keyword: row.name,
          selectKey: "Company",
        },
      });
      window.open(routeData.href, "_blank");
    },
    // 九宫格
    getShareholderSummaryList() {
      getShareholderSummary({ id3a: this.$route.query.id3a }).then((res) => {
        if (res.code == 200) {
          this.gridList = [
            {
              label: this.$t("Relationship.UItimateBeneficiaryOwner"),
              value: res.data.ultimateBeneficiary || "-",
            },
            // {
            //   label: this.$t("Relationship.ControllingShareholder"),
            //   value: res.data.controllingCount || "-",
            // },
            {
              label: this.$t("Relationship.PartiesInvolved"),
              value: res.data.participation || "-",
            },
            {
              label: this.$t("Relationship.NaturalPersonShareholders"),
              value: res.data.individualCount || "-",
            },
            {
              label: this.$t("Relationship.CorporateShareholders"),
              value: res.data.enterpriseCount || "-",
            },
            {
              label: this.$t("Relationship.ShareholderLevel"),
              value: res.data.penetrationDepth || "-",
            },
          ];
        }
      });
    },

    getShareholderChartSummaryList() {
      getShareholderChartSummary({
        id3a: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.shareholderChartSummaryObject = res.data;
        }
      });
    },

    // 股东穿透图
    getCompanyDetailchirtList() {
      getCompanyDetailchirt({
        id3a: this.$route.query.id3a,
        page: "1",
        pageSize: "50",
      }).then((Res) => {
        if (Res.code == 200) {
          let ecahrtsdata = Res.data || {};
          ecahrtsdata = JSON.parse(
            JSON.stringify(ecahrtsdata)
              .replace(/name/g, "entname")
              .replace(/entnameNative/g, "entnameen")
              .replace(/entinvs/g, "parents"),
          );
          this.chartData = ecahrtsdata;
        }
      });
    },
    
    // openD() {
    //   this.$emit("showInquiry");
    // },
    //获取股东List
    getOwnership() {
      const id3a = this.$route.query.id3a;
      getOwnership({
        id3a: id3a,
        page: this.searchParams.currentPage,
        pageSize: this.searchParams.pageSize,
      })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.rows;
            this.tableData.map((item) => {
              item.relations =  formatNum(item.relations);
            });
            this.total = res.data.total;
          }
        })
        .catch((err) => {});
    },

    // 点状关系图
    getShareholderChartApi() {
      this.loading = true;
      getShareholderChart({
        aaaid: this.$route.query.id3a,
      })
        .then((res) => {
          this.relationshipChartData = res.data;
          this.companyList = res.data.nodes;
          // this.companyList = res.data.nodes.filter(
          //   (node) => node.nodeType === "Company",
          // );
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },

    // 查询关系
    async getRelationshipApi(node) {
      let params = {
        targetCompany: this.$route.query.id3a,
        queriedCompany: node.aaaid,
        type: "1",
      };
      let res = await getRelationshipInquiryOfHolder(params);

      if (res.code == 200) {
        this.relationshipSearch = [
          {
            label: this.$t("Relationship.ShareholdingLayers"),
            value: res.data.holding[0].ownerHierarchyLevel || "-",
          },
          {
            label: this.$t("Relationship.DirectShareholdingPercentage"),
            value: res.data.holding[0].directOwnershipPercentageDesc || "-",
          },
          {
            label: this.$t("Relationship.TotalOwnershipPercentage"),
            value: res.data.holding[0].totalOwnershipPercentageDesc || "-",
          },
          {
            label: this.$t("Relationship.UItimateBeneficiaryOwner"),
            value: res.data.holding[0].ultimateBeneficialOwner || "-",
          },
        ];
      }
    },

    // 查询公司
    selectCompany(val) {
      const selectedNode = this.relationshipChartData.nodes.find(
        (node) => node.id === val,
      );
      console.log("Selected Node:", selectedNode);
      if (selectedNode) {
        this.getRelationshipApi(selectedNode).then(() => {
          this.$refs.d3Ref.highlightNode(selectedNode, true);
          this.$refs.d3Ref.ishowSearchDetail = true;
        });
      }
    },
  },
  mounted() {
    this.getOwnership();
    this.getShareholderSummaryList();
    this.getShareholderChartSummaryList();
    this.getCompanyDetailchirtList();
    this.getShareholderChartApi();
  },
};
</script>
<style scoped>
.ownership_box {
  background-color: #f5f5f5;
}

.ownership-graph-left {
  width: auto;
  height: auto;
  margin-right: 200px;
}
.ownership-graph-left-item {
  height: 80px;
  line-height: 80px;
  border-bottom: 1px solid #cccccc;
}
.ownership-graph-left-item:first-child {
  border-top: 1px solid #cccccc;
}
.ownership-graph-left-name {
  display: flex;
  align-items: center;
  width: 280px;
  height: 100%;
  padding-left: 20px;
  font-family: "Arial Bold";
  font-size: 18px;
  line-height: normal;
  background: #f3f3f3;
}
.ownership-graph-left-desc {
  width: 260px;
  line-height: 22px;
  font-size: 18px;
  text-align: center;
}
.risk_table >>> .el-table__body-wrapper {
  height: 100% !important;
}
.table_header_title {
  color: rgb(96, 60, 44);
}
.link_text {
  color: #b44818;
  cursor: pointer;
}
@media (max-width: 1920px) {
  .ownership-graph-left {
    margin-right: 140px;
  }
  .ownership-graph-left-item {
    height: 60px;
    line-height: 60px;
  }
  .ownership-graph-left-name {
    width: 186px;
    padding-left: 14px;
    font-size: 16px;
  }
  .ownership-graph-left-desc {
    width: 173px;
    line-height: 16px;
    font-size: 16px;
  }
}
</style>
